import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { NavParams, PopoverController, ToastController } from '@ionic/angular';
import moment from 'moment';
import { User } from 'src/app/models/User';
import { GymBranchProvider } from 'src/app/providers/GymBranchProvider';
import { MetodoPagoProvider } from 'src/app/providers/MetodoPagoProvider';
import { ApiService } from 'src/app/services/api/api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-ticket',
    templateUrl: './ticket.page.html',
    styleUrls: ['./ticket.page.scss'],
    standalone: false
})
export class TicketPage implements OnInit {

  dataTicket: any;
  dataBranch: any;
  branch: any
  user: User = new User();
  totalTicket: any;
  metodo_pago: string;
  dataLoaded = false;
  metodos_pago;

  constructor(
    private navParams: NavParams,
    private storage: Storage,
    private branchProvider: GymBranchProvider,
    private popoverController: PopoverController,
    private api: ApiService,
    private metodoPagoProvider: MetodoPagoProvider,
    private toastController: ToastController,
    private translate: TranslateService,
  ) {
    // this.dataTicket = this.navParams.get('data');

  }

  async ngOnInit() {
    setTimeout(()=>{
      this.dataLoaded = true;
    },700)
    this.user = await this.storage.get('user');
    this.branch = await this.storage.get('branch');
    await this.getBranch();

    this.dataTicket = await this.navParams.get('data');

    this.formatPrecio();
    this.getTotal();
    await this.getAllMetodosPago();
    this.getMetodoPago();
  }
  async getBranch() {
    this.dataBranch = await this.branchProvider.getBranch(this.branch);
  }
  formatPrecio() {
    this.dataTicket.membresiasTicket.forEach(element => {

      // element.costo_final = new Intl.NumberFormat('en-MX',{minimumFractionDigits: 2}).format(element.costo_final);
      element.costo_final = parseFloat(element.costo_final).toFixed(2);
    });
    this.dataTicket.articulosTicket.forEach(element => {
      let total = (element.cantidadBuy * element.precioModificado).toFixed(2);
      // element.precioModificado = new Intl.NumberFormat('en-MX',{minimumFractionDigits: 2}).format(total);
      element.precioModificado = parseFloat(total);
    });
    this.dataTicket.puntos.forEach(element => {

      // element.puntosFormat = new Intl.NumberFormat('en-MX',{minimumFractionDigits: 2}).format(element.puntosFormat);
      element.puntosFormat = parseFloat(element.puntosFormat).toFixed(2);
    });
  }
  formatPrecioPoints(pts) {
    return new Intl.NumberFormat('en-MX', { minimumFractionDigits: 2 }).format(parseFloat(pts));
  }
  getTotal() {
    let total = 0;
    this.dataTicket.membresiasTicket.forEach(element => {
      total += parseFloat(element.costo_final);
    });
    this.dataTicket.articulosTicket.forEach(element => {
      let sub = element.precioModificado
      if (element.edited == false)
        sub = element.precioModificado - element.descuento;
      total += parseFloat(sub.toString())
    });
    this.dataTicket.puntos.forEach(element => {

      total += parseFloat(element.puntos);
    });
    this.totalTicket = total;

  }

  async getAllMetodosPago(){
    let res = await this.metodoPagoProvider.index();
    this.metodos_pago=res.data

  }

  getMetodoPago() {
    let data = [];
    this.dataTicket.membresias.forEach(element => {
      let mF = data.find(elementF => elementF == element.metodo_pago);
      if (!mF)
        data.push(element.metodo_pago);
    });
    this.dataTicket.articulos.forEach(element => {
      let mF = data.find(elementF => elementF == element.metodoPago);
      if (!mF)
        data.push(element.metodoPago);
    });
    this.dataTicket.puntos.forEach(element => {
      let mF = data.find(elementF => elementF == element.metodoPago);
      if (!mF)
        data.push(element.metodoPago);
    });
    
    if (data[0].length > 1) {
      this.metodo_pago = 'varios'
    } else {
      let mp=this.metodos_pago.filter(m=>m.id==data[0])[0].descripcion;    
      this.metodo_pago=this.translate.instant('PAYMENT_METHOD.'+mp.replace(/[\n\r| ]/g, "").toUpperCase());
    }
    
    // let mP = data[0];
    // switch (mP) {
    //   case 2:
    //     this.metodo_pago = 'Tarjeta de crédito'
    //     break;
    //   case 3:
    //     this.metodo_pago = 'Efectivo'
    //     break;
    //   case 4:
    //     this.metodo_pago = 'Puntos'
    //     break;
    //   case 5:
    //     this.metodo_pago = 'PayPal'
    //     break;
    //   case 6:
    //     this.metodo_pago = 'Transferencia'
    //     break;

    //   default:
    //     break;
    // }
  }
  formatFecha() {
    var fecha = new Date();
    return fecha.getDate() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getFullYear() + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
  }

  print(): void {

    let t: any = document.getElementById("ticket-outer-wrapper").cloneNode(true);

    let ticket_wrapper: any = t.outerHTML;

    let rect = document.getElementById("print-section").getBoundingClientRect();


    let printWindow = window.open('', 'Print', `width=${rect.width}`);

    let stylesheets: any = document.querySelectorAll('style, link[rel="stylesheet"]');

    printWindow.document.write(`
      <head>
        <meta name="viewport" content="width=${rect.width}, initial-scale=1">
        <style>
          html, 
          body {
            width:  80mm; 
            margin: 0;  
            font-family: monospace; 
          }
          .ticket-outer-wrapper {
            width:  80mm; 
            margin: 0mm; 
          }
          @media print and (width: 8cm) and (height: auto) {
            @page {
              margin: 0mm;
              margin: 0mm; 
            }
          } 
        </style>
      </head>
      <body> ${ticket_wrapper} </body>
    `);

    //printWindow.document.write(ticket_wrapper); 
    let head = printWindow.document.querySelector('head');



    stylesheets.forEach((stylesheet) => {
      //printWindow.document.write(stylesheet.outerHTML); 
    });


    printWindow.document.write(`
      <style>
        @page { 
          size: 80mm ${rect.width / .9}mm;
          margin: 0mm; 
        }
      </style>
    `);
    printWindow.document.close();

    printWindow.resizeTo(rect.width, rect.height);

    printWindow.onload = function () {
      printWindow.focus();
      printWindow.onresize = () => {
        printWindow.resizeTo(rect.width, rect.height);
      };
      printWindow.print();

    };
  }

  cerrarTicket() {
    this.popoverController.dismiss();
  }

  async sendTicket() {
    
    let data = {
      fecha_compra: moment(this.dataTicket.fecha).format('DD/MM/YYYY HH:mm'),
      detallesVenta:[
    ],
      total:this.totalTicket,
      id_user: this.dataTicket.id
    }
    this.dataTicket.membresias.forEach(concept => {
      data.detallesVenta.push({
        nombre:this.dataTicket.membresiasTicket.find(e=>e.id == concept.id).nombre,
        pivot: {cantidad:1},
        precio:  concept.costo_final,
      });
    });
    this.dataTicket.articulos.forEach(concept => {
      let nombre =concept.nombre;
      if(concept.varianteSelected.length > 0){
        nombre += ' '+concept.varianteSelected[0].nombre;
      }
      data.detallesVenta.push({
        nombre:nombre,
        pivot: {cantidad:concept.cantidadBuy},
        precio: concept.precioModificado
      });
    });
    
    let send = await this.api.post('api/venta/send-receipt-email',{dataTicket:data } );
    const toast = await this.toastController.create({
      message: 'Se envio un correo al usuario con los datos de la venta',
      duration:2000,
    });
    toast.present();
  }
}
